import React, { useEffect, useMemo } from 'react';
import { connect, useDispatch, useSelector } from 'react-redux';
import { useHistory, useLocation, useParams } from 'react-router-dom';

import i18n from 'utils/I18n';
import QRCode from 'qrcode.react';
import queryString from 'query-string';

import { createAction, getCustomerQRCodeData } from 'utils';
import { APP_NAME, DOWNLOAD_APP_DOMAIN, PRIMARY_SIGN_UP_METHOD } from 'utils/Config';
import { detectIsMobileByScreenWidth } from 'utils/ScreenUtils';
import { QUERY_STRING_CONFIG } from 'utils/UrlUtils';

import './EventRegisterResult.scss';
import { CUSTOMER_SIGN_UP_METHOD } from 'utils/CustomEnums';
import { isNotSimplifiedNoWebapp } from 'utils/UIConfigUtils';
import { openLoginPage } from "utils/SSOUtil"

const EventRegisterResult = ({
  language,
  preRegisterData,
  isLogin
}) => {
  const dispatch = useDispatch();
  const isMobileView = detectIsMobileByScreenWidth();
  const history = useHistory();
  const params = useParams();
  const location = useLocation();

  const parsed = queryString.parse(location.search, QUERY_STRING_CONFIG);
  const campaignID = params?.id;
  const { campaignName } = useSelector((state) => {
    return {
      campaignName: state.campaignDetail[campaignID]?.data.basic.name,
    };
  });
  const uid = parsed?.uid || location.state?.uid;
  const memberShipID = parsed?.memberShipID || location.state?.memberShipID;
  const codeString = getCustomerQRCodeData(uid, memberShipID, Date.now());
  const redirectTo = isNotSimplifiedNoWebapp() ? "" : "/user/completed_success"

  const email = useMemo(() => {
    if (PRIMARY_SIGN_UP_METHOD === CUSTOMER_SIGN_UP_METHOD.MOBILE_PHONE_NUMBER) {
      return null;
    };
    return preRegisterData?.email;
  }, [PRIMARY_SIGN_UP_METHOD, preRegisterData?.email])

  const mobile = useMemo(() => {
    if (PRIMARY_SIGN_UP_METHOD === CUSTOMER_SIGN_UP_METHOD.EMAIL_ADDRESS) {
      return null;
    };
    if (!preRegisterData?.countryCode || !preRegisterData?.phoneNumber) {
      return null;
    }
    return `${preRegisterData?.countryCode}${preRegisterData?.phoneNumber}`;
  }, [PRIMARY_SIGN_UP_METHOD, preRegisterData?.countryCode, preRegisterData?.phoneNumber])

  const getJoinUsText = () => {
    if (!isNotSimplifiedNoWebapp()) {
      return isLogin ? i18n.t('event_ticket_view') : i18n.t('download_for_rewards');
    }
    return i18n.t('join_for_rewards');
  };

  console.log(campaignID, uid, memberShipID, codeString);
  useEffect(() => {
    dispatch(
      createAction('campaignDetail/getCampaignDetail')({
        campaignID,
      }),
    );
  }, [campaignID, language, dispatch]);

  useEffect(() => {
    if (uid && memberShipID) {
      dispatch(
        createAction("campaignDetail/getRegisterInfo")({
          membershipId: memberShipID,
          ssoUid: uid,
        })
      );
    }
  }, [uid, memberShipID])

  useEffect(() => {
    if (isNotSimplifiedNoWebapp()) { return }
    const handleBeforeUnload = (event) => {
      // console.log("handleBeforeUnload logout")
      event.preventDefault();
      dispatch({
        type: 'users/logout',
        payload: {},
      });
    };
    window.addEventListener('beforeunload', handleBeforeUnload);
    return () => {
      window.removeEventListener('beforeunload', handleBeforeUnload);
    };
  }, []);

  useEffect(() => {
    if (isNotSimplifiedNoWebapp()) { return }
    const unblock = history.block(() => {
      // console.log("history block logout")
      dispatch({
        type: 'users/logout',
        payload: {},
      });
      return undefined;
    });

    return () => { unblock(); };
  }, [history]);

  useEffect(() => {
    if (isMobileView) {
      dispatch(
        createAction('navBars/updateState')({
          backBtnAction: () => {
            history.push(`/campaign/${campaignID}`);
          },
        }),
      );
    }
    return () => {
      if (isMobileView) {
        dispatch(
          createAction('navBars/updateState')({
            backBtnAction: null,
          }),
        );
      }
    };
  }, []);
  return (
    <div className="register-event-result-container">
      <img
        className='success-tick'
        alt="success"
        src="/campaignDetail/SuccessTick.png"
        srcSet="/campaignDetail/SuccessTick@2x.png 2x, /campaignDetail/SuccessTick@3x.png 3x"
      />
      <div className="thank-you-register subheading">
        {i18n.t('thank_you_for_registering_for_campaign', { campaignName })}
      </div>
      <div className="qr-code-title body-2">
        {i18n.t('below_is_qrcode_for_entry')}
      </div>
      <div className="qr-code-container">
        <QRCode value={codeString} renderAs="svg" />
      </div>
      <div className="join-us-text body-2">
        {getJoinUsText()}
      </div>
      <div className="button-container">
        <button className="register-btn button-large" onClick={() => {
          if (!isNotSimplifiedNoWebapp()){
            window.location.href = DOWNLOAD_APP_DOMAIN;
          } else {
            openLoginPage({
              locale: language || "en" ,
              redirectTo,
              isEventRegister: false,
              enableOtp: false,
              email,
              mobile,
              ticketRegisterAsMember: true,
            })
          }

        }}>
          {!isNotSimplifiedNoWebapp() ? i18n.t('download_app') :i18n.t('register_as_a_member_of_app', { appName: APP_NAME })}
        </button>
        <button
          className="go-back-btn button-large"
          onClick={() => {
            if (!isNotSimplifiedNoWebapp()) {
              dispatch({
                type: 'users/logout',
                payload: {},
              });
            }
            history.push(`/campaign/${campaignID}`)
          } }
        >
          {i18n.t('go_to_event_detail')}
        </button>
      </div>
    </div>
  );
};

const mapStateToProps = (state) => ({
  language: state.users.language,
  isLogin: state.users.isLogin,
  preRegisterData: state.campaignDetail.preRegisterData,
});

export default connect(mapStateToProps)(EventRegisterResult);
